if (!customElements.get('video-testimonials-slider')) {
  class VideoTestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.initializeVideoCards();
      this.initializeSlider();
    }

    initializeVideoCards() {
      const videoCards = this.querySelectorAll('.video-testimonial-card__video-wrapper');
      
      videoCards.forEach(card => {
        const playBtn = card.querySelector('.video-testimonial-card__play-btn');
        const poster = card.querySelector('.video-testimonial-card__poster');
        const videoContainer = card.querySelector('.video-testimonial-card__video-container');
        const video = card.querySelector('.video-testimonial-card__video');
        
        if (playBtn && videoContainer) {
          playBtn.addEventListener('click', () => {
            this.playVideo(card, poster, videoContainer, video);
          });
        }
      });
    }

    playVideo(card, poster, videoContainer, video) {
      if (poster) poster.style.display = 'none';
      videoContainer.style.display = 'block';

      if (video) {
        video.removeAttribute('poster');
        video.muted = false;
        video.play();
      }
      
      card.classList.add('video-playing');
    }

    initializeSlider() {
      const isProductSection = this.closest('.main-product-new');
      const enableSlider = this.dataset.enableSlider === 'true';
      
      if (!enableSlider) return;
      if (typeof window.FoxTheme === 'undefined' || typeof window.FoxTheme.Carousel === 'undefined')  return;
    
      const sliderOptions = {
        slidesPerView: this.dataset.slidesPerViewMob || 2.5,
        spaceBetween: 12,
        navigation: {
          nextEl: this.closest('.section').querySelector('.swiper-btn-next'),
          prevEl: this.closest('.section').querySelector('.swiper-btn-prev'),
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: this.dataset.slidesPerViewTab || 4.5,
          },
          1280: {
            slidesPerView: this.dataset.slidesPerViewDesk || 5.5,
          }
        },
        loop: false,
        threshold: 2,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchStartPreventDefault: false,
        on: {
          slideChange: () => {
            this.updateNavigationState();
          },
          init: () => {
            this.updateNavigationState();
          }
        }
      };

      if (isProductSection) {
        sliderOptions.slidesOffsetAfter = 20;
        sliderOptions.breakpoints["768"].slidesOffsetAfter = 20;
        sliderOptions.breakpoints["1280"].slidesOffsetAfter = 20;
      }
      
      this.swiper = new window.FoxTheme.Carousel(this, sliderOptions);
      this.swiper.init();
    }

    updateNavigationState() {
      if (!this.swiper) return;
      
      const prevBtn = this.closest('.section').querySelector('.swiper-btn-prev');
      const nextBtn = this.closest('.section').querySelector('.swiper-btn-next');
      
      if (prevBtn) prevBtn.disabled = this.swiper.isBeginning;
      if (nextBtn) nextBtn.disabled = this.swiper.isEnd;
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy();
    }
  }

  customElements.define('video-testimonials-slider', VideoTestimonialsSlider);
}
